<template>
  
  <section>
    
	<div class="header header-fixed header-auto-show header-logo-app">
        <a href="/dashboard" class="header-title"><img src="./../assets/images/logonetcar.png" height="45px"></a>
		<a href="/dashboard" data-back-button class="header-icon header-icon-1"><i class="fas fa-arrow-left"></i></a>
	</div>
 
  </section>

</template>

<script>

//import { mapState } from 'vuex'

export default {
    methods: {
      logout: function () {
        this.$store.dispatch('logout')
        .then(() => {
          this.$router.push('/login')
        })
      }
    }
}
</script>
